import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import AddFriend from './AddFriend'

const FriendListPageOne = () => {
  const { formattedExerciseName } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageOneTranslations = t('pages.0')

  return (
    <div className="max-w-[650px]">
      <div className="mb-4 flex flex-row justify-between">
        <h3>{pageOneTranslations.relationship_category}</h3>
        <h3 className="mr-[50px]">{pageOneTranslations.relationship_scale}</h3>
      </div>
      <h4 className="mb-2">{pageOneTranslations.family}</h4>
      <AddFriend slug="family" className="mb-8" />
      <h4 className="my-2">{pageOneTranslations.friends}</h4>
      <AddFriend slug="friends" className="mb-8" />
      <h4 className="my-2">{pageOneTranslations.coworkers}</h4>
      <AddFriend slug="coworkers" />
    </div>
  )
}

export default FriendListPageOne
